import { BaseEntity } from './base-entity';

export class Action extends BaseEntity {
    Model: string = null;
    Name: string = null;
    Description: string = null;
    DefaultValue: boolean = null;
    SendToClient: boolean = null;
    RoleIDs: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Model = input.Model;
        this.Name = input.Name;
        this.Description = input.Description;
        this.DefaultValue = input.DefaultValue;
        this.SendToClient = input.SendToClient;
        this.RoleIDs = input.RoleIDs;
        return this;
    }

    
    Serialize(input: Action){
        return input;
    }
}
